import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const impersonateUser = (userId, callback, errCallback) => {
  return async (dispatch) => {
    dispatch({ type: 'IMPERSONATE_USER' });
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/users/${userId}/impersonate`, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
          if (response.status === 200) {
            dispatch({
              type: 'IMPERSONATE_USER_DONE',
            });
            const impersonateToken = response.data?.token || response.data;
            if (typeof callback === 'function') callback(impersonateToken);
          } else {
            dispatch({
              type: 'IMPERSONATE_USER_FAILED',
              payload: response?.data,
            });
            if (typeof errCallback === 'function') errCallback();
          }
        } catch (e) {
          console.log(e);
          dispatch({
            type: 'IMPERSONATE_USER_FAILED',
            payload: e?.message,
          });
          if (typeof errCallback === 'function') errCallback();
        }
      } else {
        dispatch({
          type: 'IMPERSONATE_USER_FAILED',
          payload: 'User not authenticated',
        });
        if (typeof errCallback === 'function') errCallback();
      }
      unsubscribe();
    });
  };
};

export default impersonateUser;
